import React, { useEffect, useState } from "react";
import style from "../candidatePipeline/pipeline.module.scss";
import funnelIcon from "../../../assets/images/funnelicon.svg";
import adminFilter from "../../../assets/images/AdminFilterSvG.svg";
import { decryptedAdminID, Detailsshow, MyModal } from "../../../utility";
import Dailyanlytics from "../../../assets/images/data-analytics-report.svg";
import Followup from "../../../assets/images/followupimage.svg";
import phoneNumber from "../../../assets/images/phoneimage3.svg";
import Candidatedetailstyle from "../../../components/ModalPopups/Candidatedetails.module.scss";
import CandidateFunnel from "../../CandidateFunnel/CandidateFunnel";
import { RxCross2 } from "react-icons/rx";
import SquareComtainer from "../../../components/SquarePopup";
import ModalContainer from "../../../components/modal_popup";
import { MenuItem, TextField } from "@mui/material";
import { GetAllAdminDetails, getJobFilterOptions } from "../../../apiServices";
import { useDispatch } from "react-redux";
import { CandidatePipelineActions } from "../../../redux-store/store";
import { useSelector } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import AdminDailyAnalyticsCount from "./AdminDailyAnalyticsCount";
import MobileNumberfilter from "./MobileNumberfilter";
import CandidateCallRemainder from "../../Candidate/CandidateCallRemainder/CandidateCallRemainder";
function CandidateFunnelCount() {
  const [showfunnelOpen, setshowfunnelOpen] = useState(false);
  // const [isTeamLeader, setIsTeamLeader] = useState(false);

  const [openoverallFilter, setopenoverallFilter] = useState(false);
  const [opendailycount, setopendailycount] = useState(false);
  const [opencallremainder, setopencallremainder] = useState(false);
  const [openmobilenumber, setopenmobilenumber] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [filterData, setFilterData] = useState({
    assignTo: "",
    myTeam: "",
  });
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  const teamLeader = localStorage.getItem("teamLeader");
  // console.log(teamLeader);
  let isSuperAdmin = adminDetailsRole.roleID === 1;
  const dispatch = useDispatch();
  function handleOpenFunnel() {
    setshowfunnelOpen(true);
  }
  function handleClose() {
    setshowfunnelOpen(false);
  }
  // useEffect(() => {
  //   GetAllAdminDetails()
  //     .then((data) => {
  //       // console.log(data);
  //       const activeAdmins = data.filter(
  //         (item) => !item.Deactived && item.Module !== "Developer"
  //       );
  //       setAdminList(activeAdmins);
  //     })
  //     .catch(() => {
  //       alert("Something Went wrong");
  //     });
  // }, []);

  useEffect(() => {
    const teamLeaderId = localStorage.getItem("teamLeaderId");
    const teamLeader = localStorage.getItem("teamLeader");
    GetAllAdminDetails()
      .then((data) => {
        const withoutleaderID = teamLeaderId;
        const withoutleader = teamLeader;
        const activeAdmins = data.filter((item) =>
          !item.Deactived &&
          item.Module !== "Developer" &&
          withoutleader == "true"
            ? item.id != withoutleaderID
            : item.id
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something Went wrong");
      });
  }, []);

  // function handleFieldChange(field, value) {
  //   setFilterData((prev) => ({ ...prev, [field]: value }));
  // }
  function handleFieldChange(value) {
    // alert(value);
    setFilterData((prev) => {
      let updatedData;

      let assignTo = decryptedAdminID();

      if (value === "myTeam") {
        updatedData = {
          ...prev,
          myTeam: true,
          assignTo: assignTo,
        };
      } else {
        updatedData = {
          ...prev,
          myTeam: false,
          assignTo: value,
        };
      }
      return updatedData;
    });
  }

  function handleSubmit() {
    dispatch(CandidatePipelineActions.setAssignToForAll(filterData.assignTo));
    dispatch(CandidatePipelineActions.setmyTeam(filterData.myTeam));

    setopenoverallFilter(false);
  }
  const handleClear = () => {
    const updatedAssignTo = decryptedAdminID();
    dispatch(CandidatePipelineActions.setmyTeam(true));
    setFilterData({
      assignTo: updatedAssignTo,
      myTeam: true,
    });
  };
  return (
    <>
      {/* <div
        className={`cursor-pointer ${style.LeadCount}`}
        onClick={handleOpenFunnel}
      >
        <img
          src={funnelIcon}
          alt="funnelIcon"
          className={`ms-1 ${style.funnelimg}`}
          title="Funnel"
        />
      </div> */}
      <div
        className={`cursor-pointer ${style.LeadCount4}`}
        onClick={() => {
          setopendailycount(true);
        }}
      >
        <img
          src={Dailyanlytics}
          alt="adminFilter"
          className={`ms-1 ${style.funnelimg1}`}
          title="Daily Analytics (interview Details)"
        />
      </div>

      <div
        className={`cursor-pointer ${style.LeadCount2}`}
        onClick={() => {
          setopenmobilenumber(true);
        }}
      >
        <img
          src={phoneNumber}
          alt="adminFilter"
          className={`ms-1 ${style.funnelimg1}`}
          title="Mobile Number Filter"
        />
      </div>
      {/* <div
        className={`cursor-pointer ${style.LeadCount}`}
        onClick={() => {
          setopencallremainder(true);
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={Followup}
          alt="Followup"
          className={`ms-1 ${style.funnelimg1}`}
          style={{ width: "150%", height: "150%" }}
          title="Followup's & Call's"
        />
      </div> */}
      {/* {isSuperAdmin && ( */}
      {(isSuperAdmin || teamLeader == "true") && (
        <div
          className={`cursor-pointer ${style.LeadCount3}`}
          onClick={() => {
            setopenoverallFilter(true);
          }}
        >
          <img
            src={adminFilter}
            alt="adminFilter"
            className={`ms-1 ${style.funnelimg1}`}
            title="Assigned To Filter"
          />
        </div>
      )}

      {/* {isSuperAdmin && ( */}

      <div>
        {showfunnelOpen && (
          <Detailsshow>
            <SquareComtainer
              topComponent={
                <>
                  <div className={`${Candidatedetailstyle.boxcross}`}>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h4 className="text-light ms-3">{}</h4>
                      </div>
                      <div
                        className={` ${Candidatedetailstyle.CrossStyle} pe-5 pe-lg-4`}
                      >
                        <b>
                          <RxCross2
                            className="text-light"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleClose();
                            }}
                          />
                        </b>
                      </div>
                    </div>
                  </div>
                </>
              }
              childComponent={
                <>
                  <div>
                    <CandidateFunnel />
                  </div>
                </>
              }
            />
          </Detailsshow>
        )}
        {openoverallFilter && (
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div style={{ width: "300px" }}>
                    <div className="d-flex justify-content-between aligin-items-center">
                      <div className="text=center">
                        <b>Overall Filter for pipeline</b>{" "}
                      </div>
                      <div
                        className="btn btn-danger"
                        onClick={() => {
                          setopenoverallFilter(false);
                        }}
                      >
                        <AiOutlineClose />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm-12">
                        {" "}
                        {/* <TextField
                          onChange={(e) =>
                            handleFieldChange("assignTo", e.target.value)
                          }
                          name="AssignedTo"
                          id="AssignedTo"
                          className="form-control"
                          select
                          label="Assigned To"
                          value={filterData.assignTo}
                          defaultValue={filterData.assignTo}
                        >
                          <MenuItem value={-1}>ALL</MenuItem>
                          <MenuItem value={decryptedAdminID()}>
                            Only For Me
                          </MenuItem>
                          {adminList.map((el) => (
                            <MenuItem key={el.id} value={el.id}>
                              {el.userName}
                            </MenuItem>
                          ))}
                        </TextField> */}
                        <TextField
                          onChange={(e) => handleFieldChange(e.target.value)}
                          name="assignTo"
                          id="assignTo"
                          className="form-control"
                          select
                          label="Assigned To"
                          value={
                            filterData.myTeam ? "myTeam" : filterData.assignTo
                          }
                        >
                          {isSuperAdmin && <MenuItem value="-1">ALL</MenuItem>}
                          {!isSuperAdmin && teamLeader == "true" && (
                            <MenuItem value="myTeam">My team</MenuItem>
                          )}
                          {teamLeader == "true" && ( 
                            <MenuItem value={decryptedAdminID()}>
                              Only for me
                            </MenuItem>
                          )}
                          {adminList.map((el) => (
                            <MenuItem key={el.id} value={el.id}>
                              {el.userName}
                            </MenuItem>
                          ))}
                        </TextField>
                        {/* <TextField
                          onChange={(e) => {
                            const value = e.target.value;
                            console.log("Selected Value:", value);

                            handleFieldChange("assignTo", value);
                            if (value === decryptedAdminID()) {
                              console.log("Setting myTeam to false");
                              handleFieldChange("myTeam", false);
                            } else {
                              console.log("Setting myTeam to true");
                              handleFieldChange("myTeam", true);
                            }
                          }}
                          name="AssignedTo"
                          id="AssignedTo"
                          className="form-control"
                          select
                          label="Assigned To"
                          value={filterData.assignTo}
                          defaultValue={filterData.assignTo}
                        >
                          <MenuItem value={-1}>ALL</MenuItem>
                          <MenuItem value={decryptedAdminID()}>
                            Only For Me
                          </MenuItem>
                          {adminList.map((el) => (
                            <MenuItem key={el.id} value={el.id}>
                              {el.userName}
                            </MenuItem>
                          ))}
                        </TextField> */}
                      </div>
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-2">
                      <div className="btn btn-danger" onClick={handleClear}>
                        Clear
                      </div>
                      <div
                        className="btn text-light"
                        style={{ backgroundColor: "#169c50" }}
                        onClick={handleSubmit}
                      >
                        Submit
                      </div>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        )}
        {opendailycount && (
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div>
                    <AdminDailyAnalyticsCount
                      setopendailycount={setopendailycount}
                    />
                  </div>
                </>
              }
            />
          </MyModal>
        )}
        {opencallremainder && (
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div>
                    <CandidateCallRemainder
                      // setopencallremainder={setopencallremainder}
                      onclose={() => setopencallremainder(false)}
                    />
                  </div>
                </>
              }
            />
          </MyModal>
        )}
        {openmobilenumber && (
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div>
                    <MobileNumberfilter
                      setopenmobilenumber={setopenmobilenumber}
                    />
                  </div>
                </>
              }
            />
          </MyModal>
        )}
      </div>
    </>
  );
}

export default CandidateFunnelCount;
